import IResponse = ZoneIQCalibration.IResponse;
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { CalibrationParkingValue } from '../../models/calibrations/calibration-parking-value.model';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-parking';

@Injectable({
    providedIn: 'root'
})
export class CalibrationParkingService {
    constructor(private readonly http: HttpClient) {}

    saveChanges(calibrationParkingData: CalibrationParkingValue[]) {
        if (!_.get(calibrationParkingData, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(API, calibrationParkingData, { headers, params });
    }
}
